import changeTab from './helpers/items';
import Prices from './prices';

export default class Element {

    /**
     * Constructor of class
     * @param {Object} element 
     * @param {String} content 
     */
    constructor(element, content) {
        this.element = element;
        this.content = content;

        this.initElement();
        this.unbindElement(true);
        this.bindElement();
    }

    /**
     * Method to initialize element
     */
    initElement() {

        $(document).ready(() => {

            this.element.color = $(this.element.inputColor).val();
            this.element.size = $(this.element.inputSize).val();
            this.element.font = $(this.element.inputFont).val();

        });

    }

    /**
     * Method to binding changes on element
     */
    bindElement() {

        if (this.element.type === 'text' || this.element.type === 'number') { 
            $(document).ready(() => {

                $(this.element.inputText).on('keyup', (event) => {
    
                    if ($(this.element.id).size() <= 0 && $(this.element.inputText).val() !== '') {

                        this.createElement();
        
                    } else {
                        this.element.value = $(event.currentTarget).val();
                        this.updateText($(event.currentTarget).val());
            
                    }
        
                });
        
                $(this.element.inputText).on('blur', () => {
        
                    if(this.element.value == '' || !this.element.value) {
                        this.removeElement();
                    }
        
                });
    
            });
        }

        else {

            $(document).ready(() => {

                $(this.element.input).change(() => {

                    if ($(this.element.input).prop('files')[0]) {

                        this.removeElement(false);

                        let form = new FormData(); 
                        form.append('file', $(this.element.input).prop('files')[0]);
                        form.append('guid', $('#personalizator__guid').val());

                        $.ajax({
                            url: '/personalizacja/upload/',
                            dataType: 'text',
                            cache: false,
                            contentType: false,
                            processData: false,
                            data: form,                         
                            type: 'post',
                            success: (response) => {
                                this.element.image = JSON.parse(response).file;
                                this.createElement();
                                this.unbindElement(true);
                            }
                        });

                    }

                });

            });
        }

        this.bindChangeFont();
        this.bindChangeFontSize();
        this.bindChangeColor();
        
    }

    /**
     * Method to create new lement in content
     */
    createElement() {

        if (this.element.type === 'text' || this.element.type === 'number') {

            $(`<div id="${this.element.name}" class="personalizator__fly personalizator__element" data-tab="${this.element.tab}">
                    <div class="text" style="color: ${this.element.color}; font-size: ${this.element.size}px; font-family: '${this.element.font}'">
                        ${$(this.element.inputText).val()}
                    </div>
                    <div class="remove personalizator__fly-remove">&nbsp;</div>
                </div>`).appendTo(this.content);

        } else { 

            $(`<div id="${this.element.name}" class="personalizator__fly personalizator__element" data-tab="${this.element.tab}">
                    <div class="image" >
                        <img src="/${this.element.image}" />
                    </div>
                    <div class="remove personalizator__fly-remove">&nbsp;</div>
                </div>`).appendTo(this.content);

        }

        this.bindEvents();
        this.bindTextDRR();
        this.updateElemet();
    }

    /**
     * Method to update content of element
     * @param {String} text 
     */
    updateText(text) {

        if (this.element.type === 'text' || this.element.type === 'number') {

            const el = $(this.element.id).find('.text');
            let style;

            el.text(text);

            $(this.element.id).css('width', el.textWidth(text, this.element.font, this.element.size));
        }

    }

    /**
     * Method to bind events like click etc.
     */
    bindEvents() {
        $(document).ready(() => {
            $(this.element.id).on('click', (event) => {
                
                if (this.element !== 'img') {
                    this.unbindElement();
                    this.pickAllValues();
                    $(this.element.inputText).focus().val(this.element.value);

                    this.changeFont(this.element.font);
                    this.changeFontSize(this.element.size);
                    this.changeColor(this.element.color);
                }

                changeTab($(event.currentTarget).data('tab'));
                this.bindElement();

            });

            $(this.element.id).find('.remove').on('click', (event) => {

                this.removeElement();

            });
            

            if (this.element.type === 'img') {
                $(this.element.id).click();
            }

        });
    }

    /**
     * Method to bind jQuery UI Draggable, Resizable, Rotatable
     */
    bindTextDRR() {

        $(this.element.id)
            .draggable({
                start: (event, ui) => {
                    changeTab($(this.element.id).data('tab'));
                    $(this.element.id).click();
                },
            })
            .resizable({
                aspectRatio: true,
                grid: 1,
                start: (event, ui) => {
                    changeTab($(this.element.id).data('tab'));
                    $(this.element.id).click();
                },
                resize: (event, ui) => {
                    
                    if(this.element.type !== 'img') {
                        this.changeFontSize(ui.size.height);                   
                        this.updateText(this.element.value);
                    }

                    this.updateElemet();

                }

            })
            .rotatable({
                start: (event, ui) => {
                    changeTab($(this.element.id).data('tab'));
                    $(this.element.id).click();
                }
            });
            
    }

    /**
     * Method to remove element from current content
     * @param {Boolean} clear if true then clear inputs
     */
    removeElement(clear) {

        if(typeof clear === 'undefined') {
            clear = true;
        }

        if(clear) {

            if(this.element.type === 'number' || this.element.type === 'text') {
         
                $(this.element.inputText).val(null);
             
            } else {
    
                $(this.element.input).val(null);
    
            }

        }

        $(this.element.id).remove();
        this.updateElemet();
    }

    /**
     * Method to change color on element
     * @param {String} color 
     */
    changeColor(color) {

        this.element.color = color;

        $(this.element.id).find('.text').css('color', color);
        $(this.element.inputText).trigger('keyup');
        this.updateElemet();
    }

    /**
     * Method to change font family on element
     * @param {String} font 
     */
    changeFont(font) {

        this.element.font = font;

        $(this.element.id).find('.text').css('font-family', font);

        $(this.element.inputFont).val(this.element.font).trigger('chosen:updated.chosen');

        $(this.element.inputText).trigger('keyup');
        this.updateElemet();
    }

    /**
     * Method to change font size on element
     * @param {Number} fontSize 
     */
    changeFontSize(fontSize) {

        this.element.size = fontSize;

        $(this.element.id).find('.text').css('font-size', `${fontSize}px`);
        
        $(this.element.inputSize).val(this.element.size).trigger('chosen:updated.chosen');

        $(this.element.inputText).trigger('keyup');

        this.updateElemet();
    }

    /**
     * Method to change color binding
     */
    bindChangeColor() {

        $(document).ready(() => {

            $(this.element.inputColor).on('change', (event) => {

                this.changeColor($(event.currentTarget).val());

            });

        });

    }

    /**
     * Method to change font binding
     */
    bindChangeFont() {

        $(document).ready(() => {

            $(this.element.inputFont).on('change', (event) => {

                this.changeFont($(event.currentTarget).val());

            });

        });

    }

    /**
     * Method to change font size binding
     */
    bindChangeFontSize() {

        $(document).ready(() => {

            $(this.element.inputSize).on('change', (event) => {

                this.changeFontSize($(event.currentTarget).val());

            });

        });

    }

    /**
     * Method to update elements data
     */
    updateElemet() {

        if (this.element.id) {

            $(this.element.id).data('element', JSON.stringify(this.element));
        
            Prices.updatePrices();

        }

    }

    unbindElement(stayTab) {

        if (!stayTab) {
            $(this.element.tab).removeClass('active');
            $(`li[data-tab="${this.element.tab}"]`).removeClass('active');
        }

        if(this.element.type !== 'img') {
            $(this.element.inputText).unbind();
            $(this.element.inputFont).unbind('change');
            $(this.element.inputSize).unbind('change');
            $(this.element.inputColor).unbind('change');
            $(this.element.inputText).val('');
        } else {

            $(this.element.input).unbind();
            $(this.element.inputAttachment).unbind();

        }
    }

    pickAllValues() {

        // font
        $(this.element.inputFont).val(this.element.font).trigger('change');

        // size
        $(this.element.inputSize).val(this.element.size).trigger('change');

        // color
        $(this.element.inputColor).val(this.element.color).trigger('change');
        $(this.element.inputColor).parent().find(`[data-color="${this.element.color}"]`).click();

    }

}
